/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { action } from "@ember/object";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type NavigationService from "parog-web/services/navigation";
import type SemeiaSessionService from "parog-web/services/session";
import Ember from "ember";

// tells Tailwind that h-[50px] must be part of wiser.css;
const navbarHeightStyle = "h-[50px]";
export function navbarHeight() {
  return (navbarHeightStyle.match(/\d+/) as [string])[0];
}

const firstLevelPages = [
  "medics-web.protected.index.alerts-and-notifications",
  "medics-web.protected.index.alerts-and-notifications_loading",
  "medics-web.protected.index.tasks-and-consultations",
  "medics-web.protected.index.tasks-and-consultations_loading",
  "medics-web.protected.index.patient-list",
  "medics-web.protected.index.patient-list_loading",
  "patient-web.protected_loading",
  "patient-web.protected.dashboard.index"
];

const secondLevelPages = [
  "medics-web.protected.patients.patient.dashboard.main",
  "medics-web.protected.patients.patient.dashboard.main.index",
  "medics-web.protected.patients.patient.dashboard.bio-results.summary",
  "medics-web.protected.medics",
  "patient-web.protected.blood-pressure.sessions.index"
];

const returnToMedicsWebDashboardPages = [
  "medics-web.protected.patients.patient.feature.component.index",
  "medics-web.protected.patients.patient.feature.component.edition",
  "medics-web.protected.patients.patient.form",
  "medics-web.protected.patients.patient.administrative.index"
];

interface Signature {
  Args: { shouldHideProfileIcon?: boolean };
  Blocks: { default: [] };
}

export default class NavBar extends Component<Signature> {
  @service declare session: SemeiaSessionService;
  @service declare navigation: NavigationService;
  @service declare store: Store;
  @service declare router: RouterService;

  navbarHeightStyle = navbarHeightStyle;

  menuStyles = `ui top menu no-print fixed !min-h-[0px] bg-pink [box-shadow:none] ${navbarHeightStyle}`;

  titleItemSytles =
    "grow-[2] text-center !font-bold [@media_screen_and_(max-width:549px)]:m-0";

  get rootRoute() {
    if (this.session.medic) {
      if (this.isOnFirstLevelPage) return this.router.currentRouteName;
      return "medics-web.protected.index";
    } else if (this.session.patient) {
      return "patient-web.protected.dashboard.index";
    }

    return "index";
  }

  get isOnFirstLevelPage() {
    // Is there a better way of determining what route we end up on
    // after transitioning to 'index'?
    return firstLevelPages.includes(this.navigation.currentRouteName);
  }

  get shouldShowBack() {
    if (this.isOnSecondLevelPage) return false;
    return this.navigation.canGoBack;
  }

  get isOnSecondLevelPage() {
    return secondLevelPages.includes(this.navigation.currentRouteName);
  }

  get shouldReturnToMedicsWebDashboard() {
    return returnToMedicsWebDashboardPages.includes(
      this.navigation.currentRouteName
    );
  }

  get _testMode() {
    return Ember.testing;
  }

  @action
  back() {
    if (this.shouldReturnToMedicsWebDashboard) {
      this.router.transitionTo(
        "medics-web.protected.patients.patient.dashboard"
      );
    } else {
      this.navigation.back();
    }
  }

  get patients() {
    return this.store.peekAll("patient");
  }
}
